<template>
  <div class="job-page">
    <section class="banner">
      <div class="ctn">
        <h1 v-if="t == 5" class="ctn">社会招聘</h1>
        <h1 v-if="t == 6" class="ctn">校园招聘</h1>
        <p class="ctn">加入九恒 成就美好未来</p>
      </div>
    </section>
    <div class="ctn job-list">
      <h2>职位</h2>
      <ul>
        <li v-for="(item,key) in job" :key="key">
          <h3>{{ item.title }}</h3>
          <span>{{ item.area }}</span>
          <span>{{ item.job_type }}</span>
          <h4 v-show="item.expand === true">职位描述</h4>
          <p v-show="item.expand === true" v-html="item.summary.replace(/\r\n/g, '<br>')"></p>
          <h4 v-show="item.expand === true">职位要求</h4>
          <p v-show="item.expand === true" v-html="item.require.replace(/\r\n/g, '<br>')"></p>
          <time>{{ item.created_date }} 发布</time>
          <button @click="$set(item, 'expand', !Boolean(item.expand))" :class="item.expand === true ? 'expand' : 'fold'"><i>展开</i><i>收起</i></button>
          <a v-show="item.expand === true">我要投递</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0,
      job: [],
      t: 5
    }
  },
  mounted() {
    const t =  this.$route.params.t
    if (t) this.t = t
    this.getData()
  },
  methods: {
    getData() {
      axios.get('/api/v1/article/list?ctype=' + this.t).then(r => {
        if (r && r.data && r.data.list)
        this.job = r.data.list
      })
    }
  }
}
</script>
